<template lang="pug">
div
  .mb-4
  .d-flex.justify-center.mt-16(v-if="isLoading")
    v-progress-circular(:width="2" :size="50" color="primary" indeterminate)

  template(v-else)
    draggable(handle=".handle" draggable=".can-drag" :list="statuses" @start="drag = true" @end="endDrag")
      div(v-for="status in statuses" :key="status.id" :class="!status.is_default ? 'can-drag' : ''")
        v-card.round-xl.px-5.mb-3(outlined height="86")
          .d-flex.align-center.fill-height
            template(v-if="status.is_default")
              v-icon(color="neutral300") $yzi-dots-grid-02
            template(v-else)
              .handle.cursor-grab
                v-icon(color="neutral500") $yzi-dots-grid-02
            .ml-4
              .d-flex.align-center
                .text-md.font-medium.neutral700--text {{ status.name | capitalize }}
                v-tooltip(top color="black" max-width="290")
                  template(v-slot:activator="{ on }")
                    v-chip.text-sm.neutral500--text.ml-2.pr-2.pl-1(v-if="status.is_default" label small color="neutral300" v-on="on") 
                      v-icon(small) $yzi-automatic
                      .ml-1 Automatic
                  .text-xs.white--text.text-center This status is an automatic status. Yezza will use this to calculate your conversion rate.
              .text-sm.neutral700--text.mt-1 Total audience: {{ status.total_customers }}
            v-spacer
            div
              y-switch.mb-n2(v-model="status.enabled" :disabled="status.is_default" @change="enableStatus(status)")
            
            v-menu(offset-y left rounded="lg")
              template(#activator="{ on }")
                v-btn.ml-4(icon small v-on="on" :disabled="status.is_default")
                  v-icon mdi-dots-horizontal
              v-list.py-0(dense width="120")
                v-list-item(@click="editStatus(status)")
                  .text-sm.basic800--text.font-normal {{ $t('edit') }}
                v-divider
                v-list-item(@click="deleteStatus(status)")
                  .text-sm.danger500--text.font-normal {{ $t('delete') }}
      
      v-overlay(absolute :value="showOnboarding" opacity="0.8")
        .text-center
          v-avatar.mb-8(color="neutral300")
            v-icon(size="30" color="neutral500") $yzi-star-04
          .mb-1.font-semibold.text-md You can add new status
          .text-sm “New”, “Closed”, and “Reject” are the automatic status by the system. 
          .text-sm.mb-10 You can add more status in between them.
          v-btn.button-sm(outlined @click="addStatus") Create a status

    v-card.round-xl.px-4.border-dashed(link outlined height="86" @click="showAddDialog = true")
      .d-flex.align-center.fill-height
        v-avatar(color="neutral300" size="32")
          v-icon(color="neutral500" size="18") $yzi-plus
        .text-md.font-semibold.ml-4 Add status

  .dialogs
    add-status-dialog(v-if="showAddDialog" :open.sync="showAddDialog" @added="reset")
    edit-status-dialog(v-if="showEditDialog" :open.sync="showEditDialog" :status="selectedStatus" @updated="reset")
    delete-status-dialog(v-if="showDeleteDialog" :open.sync="showDeleteDialog" :status="selectedStatus" :statuses="statuses" @deleted="reset")

</template>

<script>
import draggable from 'vuedraggable'
import { mapGetters, mapActions } from 'vuex'
import AddStatusDialog from '@/components/connect/dialogs/AddStatusDialog.vue'
import EditStatusDialog from '@/components/connect/dialogs/EditStatusDialog.vue'
import DeleteStatusDialog from '@/components/connect/dialogs/DeleteStatusDialog.vue'

export default {
  name: 'Status',
  components: { draggable, AddStatusDialog, EditStatusDialog, DeleteStatusDialog },
  data: () => ({
    statuses: [],
    isLoading: false,
    selectedStatus: null,
    showAddDialog: false,
    showEditDialog: false,
    showDeleteDialog: false,
    drag: false,
    showOnboarding: false
  }),
  mounted () {
    this.fetchStatuses()
  },
  computed: {
    ...mapGetters({ company: 'getCompany' }),
  },
  methods: {
    ...mapActions(['showMessage']),
    fetchStatuses () {
      this.isLoading = true
      this.$axios.get(`/connect/${this.company.slug}/statuses?exclude=customer`)
        .then(resp => {
          this.statuses = resp.data.results
          this.checkOnboarding()
        }) 
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    addStatus () {
      this.showAddDialog = true
    },
    enableStatus (status) {
      this.$axios.patch(`/connect/${this.company.slug}/statuses/${status.id}`, { enabled: status.enabled })
        .then(() => {
          this.showMessage(['success', this.$t('success_message.successfully_updated')])
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
    },
    editStatus (status) {
      this.selectedStatus = status
      this.showEditDialog = true
    },
    deleteStatus (status) {
      this.selectedStatus = status
      this.showDeleteDialog = true
    },
    reset () {
      this.showOnboarding = false
      this.selectedStatus = null
      this.fetchStatuses()
    },
    endDrag (event) {
      this.drag = false
      const position = event.newIndex
      const status = this.statuses[position]
      if (status) {
        this.$axios.post(`/connect/${this.company.slug}/statuses/${status.id}/move`, { position })
          .then(() => {})
          .catch(() => {
            this.showMessage(['error', "Error moving reject reason"])
          })
      }
    },
    checkOnboarding () {
      if (this.statuses.length == 3 && !localStorage.getItem('yz_status_onboarding_completed')) {
        this.showOnboarding = true
      }
    }
  }
}
</script>
